import { render, staticRenderFns } from "./CustomFieldsPlaygroundComponent.vue?vue&type=template&id=6f2d2ba3&scoped=true&lang=pug"
import script from "./CustomFieldsPlaygroundComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsPlaygroundComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsPlaygroundComponent.vue?vue&type=style&index=0&id=6f2d2ba3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d2ba3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2d2ba3')) {
      api.createRecord('6f2d2ba3', component.options)
    } else {
      api.reload('6f2d2ba3', component.options)
    }
    module.hot.accept("./CustomFieldsPlaygroundComponent.vue?vue&type=template&id=6f2d2ba3&scoped=true&lang=pug", function () {
      api.rerender('6f2d2ba3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/customFieldsPlayground/CustomFieldsPlayground/CustomFieldsPlaygroundComponent.vue"
export default component.exports